import Image from 'next/image';
import imgSection3Main from 'assets/images/product-showcase-memo-variety.png';
import classNames from 'classnames';

export const Section3 = () => (
  <div className={styles.container}>
    <div className={styles.innerWrapper}>
      <div className={styles.circle} />
      <div className={styles.imageContainer.base}>
        <Image
          src={imgSection3Main}
          alt="MindFeed app preview"
          fill
          className={styles.imageContainer.image}
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
      </div>
      <div className={styles.textContainer.base}>
        <h2 className={styles.textContainer.heading}>
          Why{' '}
          <span className={styles.textContainer.highlight}>use MindFeed</span>{' '}
          to organize your notes?
        </h2>
        <p className={styles.textContainer.p1}>
          Organizing and sharing your thoughts and ideas can be challenging.
          With MindFeed, you have a simple tool to capture, organize, and access
          your notes, projects, and inspirations, anytime and on any device.
        </p>
        <p className={styles.textContainer.p2}>
          {`Whether you're a student, entrepreneur, or creative, MindFeed helps you find and share your ideas quickly without the hassle.`}
        </p>
      </div>
    </div>
  </div>
);

const styles = {
  container: 'bg-mf-gray-50 overflow-y-hidden',
  innerWrapper:
    'flex flex-col-reverse px-5 mx-auto relative lg:flex-row lg:gap-20 lg:items-center lg:mt-6 lg:max-w-7xl',
  circle: classNames(
    'absolute  rounded-full bg-mf-blue-200/40',
    // Small screens
    'left-[-100px] bottom-[-30px] w-[250px] h-[250px]',
    // Medium screens
    'md:left-[-150px] md:bottom-[-50px] md:w-[350px] md:h-[350px]',
    // Large screens
    'lg:left-[-100px] lg:bottom-[-50px] lg:w-[300px] lg:h-[300px]',
    // XLarge screens
    'xl:left-[-300px] xl:bottom-[-70px] xl:w-[400px] xl:h-[400px]',
  ),
  imageContainer: {
    base: 'w-full h-[452px] sm:h-[550px] md:h-[600px] lg:h-[705px] relative overflow-visible',
    image:
      'h-full object-contain object-left object-top md:object-center lg:object-bottom lg:object-left mx-auto',
  },
  textContainer: {
    base: 'my-10 lg:mt-[139px] lg:mb-[155px] px-4 md:px-20 lg:px-0',
    heading:
      'text-4xl font-bold text-mf-off-black-950 sm:leading-[57.28px] sm:text-5xl',
    highlight: 'text-mf-blue',
    p1: 'mt-8 text-xl text-mf-off-black-500 leading-8',
    p2: 'mt-8 text-xl font-semibold text-mf-off-black-500 leading-8',
  },
};
